// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, VALID } from '@tectonics/prs/validation';
import { validateThaiMobileBankingBankCode } from '@tectonics/prs/thailand/validation/thai-mobile-banking-bank-code';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): ?UserInputValidationError {
  switch (userInputName) {
    case 'selectedBankCode':
      return validateThaiMobileBankingBankCode(
        userInputValues.selectedPaymentMethod,
        userInputValues.selectedEWallet,
        userInputValues.selectedBankCode
      );

    default:
      return VALID;
  }
}
